export default typeof document === 'undefined' ? true : false



// WEBPACK FOOTER //
// ./src/is-node.js